import { POPUP_CLOSE, POPUP_OPEN } from '../constants';

import { PopupPayloadType } from '../actions/popupActions';

interface StateType {
  opened: string[];
}

const init: StateType = {
  opened: [],
};

type PopupActionType = { type: string; payload: PopupPayloadType; message?: string };

export default (state = init, action: PopupActionType): StateType => {
  switch (action.type) {
    case POPUP_CLOSE: {
      const { name } = action.payload;
      return { ...state, opened: [...state.opened.filter((x) => x !== name)] };
    }
    case POPUP_OPEN: {
      const { name } = action.payload;
      return { ...state, opened: [...state.opened.filter((x) => x !== name), name] };
    }
    default: {
      return state;
    }
  }
};
